
        import 'RepoStatus.a69a451.css-module'
        export default {"RepoStatus":"RepoStatus_RepoStatus_a69a451","status":"status_RepoStatus_a69a451","inSync":"inSync_RepoStatus_a69a451","notInSync":"notInSync_RepoStatus_a69a451"}
    